import React from 'react';
import { connect } from 'react-redux';
import { Menu, Button, Dropdown} from 'semantic-ui-react'
import { logout } from '../../services/User';
// import logo from '../../assets/images/newui/dealgrace_logo.png'
import hamburger_icon from '../../assets/images/newui/hamburger-icon.svg'
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { NavigationUrls } from '../../constants/NavigationUrls';
import TopNavigationBarNew from '../../components/TopNavigationBarNew/TopNavigationBarNew';

import './TopPanel.less'
import { getAllCategories } from '../../services/categories';
import { getPlans } from '../../services/subscription';

class TopPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = { windowWidth: window.innerWidth }
        this.sbrId = 0;
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: this.state.windowWidth });

    }
    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    navigateToCheckout = async () => {
        // check , either we are on open-request honeypot page or not. 
        let pathNameSplit = this.props.location.pathname.split('/');
        if(!this.props.loggedIn && pathNameSplit.slice(0,-2).join('/') == NavigationUrls.REQUESTS_BY_MARKET.split('/').slice(0,-2).join('/'))
        {
                let categorySeoName = pathNameSplit[pathNameSplit.length -1];
                const categories = await getAllCategories();
                if(categories.resStatus == 200 && categories.data.length > 0 && categorySeoName.length > 0)
                {
                    let category = categories.data.filter((cat) => {return cat.seoName == categorySeoName})
                      const plans = await getPlans(category[0].categoryID);
                      if (plans?.data?.length) {
                        const premiumPlan = plans.data.find(p => p.plan.planType == "Premium");
                        if (premiumPlan) {
                          this.props.history.push(`/business/checkout/${premiumPlan.plan.planID}`)
                        }
                        else {
                          this.props.history.push(`/business/checkout/${plans.data[0].plan.planID}`)
                        }
                      } else {
                        this.props.history.push('/business/signup')
                      }
                }else
                {
                    this.props.history.push('/business/signup')
                }
        }else
        {
            this.props.history.push('/business/signup')
        } 
    }

    render() {
        return (
            <div key="top-panel" className="master-top-panel top-panel-container" ref={this.props.pageTopRef}>
                <div className="content-panel">
                    <div className="top-bar-new">
                        <Menu className="master-menu">
                            <Menu.Item header className="header-logo">
                                <a href={ ( this.props.isCheckoutPage || (this.props.seller && this.props.seller.disableRedirection)) ? 'javascript:void(0)' : '/'}><img src='https://com-syndafy-dealgrace-static.s3.us-east-2.amazonaws.com/ServiceGrace+For+Web.png' className="logo" /></a>
                            </Menu.Item>

                            <Menu.Menu position='right' className="top-bar-links">

                                {!this.props.loggedIn && this.state.windowWidth > 768 && this.props.location.pathname != "/business/signup" &&
                                    <React.Fragment>
                                        <Menu.Item as="a" className="joinaspro" 
                                        // href="/business/signup" 
                                        onClick={() => {
                                            this.navigateToCheckout()
                                        }} name="joinaspro">Join As A Business</Menu.Item>
                                    </React.Fragment>
                                }

                                {!this.props.loggedIn && this.state.windowWidth > 768 
                                && !this.props.seller.disableRedirection &&
                                    <Menu.Item>
                                        <Button className="button-primary" href="/signin">Login</Button>
                                    </Menu.Item>
                                }

                                {!this.props.isCheckoutPage && !this.props.loggedIn && this.state.windowWidth <= 768 && (this.state.windowWidth < 768 || this.props.location.pathname != "/business/signup") &&
                                    <Menu.Item>
                                        <Dropdown className="responsive-menu" trigger={<img src={hamburger_icon} />}>
                                            <Dropdown.Menu>
                                                {this.props.location.pathname != "/business/signup" && <Dropdown.Item key='menu_joinpro' text="Join As A Business" onClick={() => {
                                                    // this.props.history.push({
                                                    //     pathname: '/business/signup',
                                                    //     state: { visitTime: moment().unix() }
                                                    // });
                                                    this.navigateToCheckout();
                                                }} icon="user" />}

                                                {this.state.windowWidth < 768 && !this.props.seller.disableRedirection &&
                                                    <Dropdown.Item key='menu_login'>
                                                        <Button className="button-primary" href="/signin">Login</Button>
                                                    </Dropdown.Item>
                                                }
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </Menu.Item>
                                }
                                {
                                    this.props.loggedIn && this.props.location.pathname.endsWith('place-bid') &&
                                    <div style={{position:"relative"}}>
                                        <div className={"top-panel-icon-container"}>
                                            <Menu.Item>
                                                <svg className={`nav-menu-open-icon ${this.props.showNavMenu ? "active" : ""}`} onClick={() => this.props.toggleNavMenu()} xmlns="http://www.w3.org/2000/svg" width="35.056" height="35.073" viewBox="0 0 35.056 35.073">
                                                    <g id="w1Lc5Z.tif" transform="translate(-899.484 -96.819)">
                                                        <g id="Group_15442" data-name="Group 15442" transform="translate(899.484 96.819)">
                                                            <path id="Path_29137" data-name="Path 29137" d="M1210.184,415.731c-1.712,0-3.425-.032-5.136.009a2.689,2.689,0,0,1-2.783-2.787c.034-3.413.01-6.826.011-10.239a2.616,2.616,0,0,1,2.791-2.8q5.121,0,10.241,0a2.6,2.6,0,0,1,2.781,2.768q0,5.151,0,10.3a2.586,2.586,0,0,1-2.013,2.676,3.707,3.707,0,0,1-.787.063C1213.587,415.734,1211.886,415.731,1210.184,415.731Z" transform="translate(-1183.036 -380.668)" fill="#e0e1e2" />
                                                            <path id="Path_29138" data-name="Path 29138" d="M899.487,104.723c0-1.744-.007-3.487,0-5.231a2.572,2.572,0,0,1,2.029-2.6,3.7,3.7,0,0,1,.756-.058c3.4,0,6.807.03,10.209-.016a2.722,2.722,0,0,1,2.83,2.841c-.04,3.423-.01,6.847-.014,10.271a2.517,2.517,0,0,1-1.578,2.485,2.85,2.85,0,0,1-1.105.22c-3.477.016-6.954.013-10.432.008a2.58,2.58,0,0,1-2.7-2.691C899.48,108.21,899.487,106.466,899.487,104.723Z" transform="translate(-899.484 -96.819)" fill="#e0e1e2" />
                                                            <path id="Path_29139" data-name="Path 29139" d="M1210.2,96.9c1.733,0,3.467.021,5.2-.006a2.614,2.614,0,0,1,2.656,2.084,4.049,4.049,0,0,1,.051.725q0,5.12,0,10.24a2.6,2.6,0,0,1-2.779,2.77q-5.136,0-10.273,0a2.612,2.612,0,0,1-2.761-2.763c0-3.434.02-6.869-.01-10.3a2.676,2.676,0,0,1,2.748-2.755C1206.757,96.933,1208.48,96.9,1210.2,96.9Z" transform="translate(-1183.057 -96.89)" fill="#e0e1e2" />
                                                            <path id="Path_29140" data-name="Path 29140" d="M907.43,415.731c-1.744,0-3.487.007-5.231,0a2.561,2.561,0,0,1-2.632-2.065,3.322,3.322,0,0,1-.053-.693q0-5.136,0-10.271a2.6,2.6,0,0,1,2.8-2.781q5.12,0,10.241,0a2.614,2.614,0,0,1,2.773,2.783q0,5.183,0,10.366a2.593,2.593,0,0,1-2.034,2.6,3.776,3.776,0,0,1-.788.058C910.812,415.734,909.121,415.731,907.43,415.731Z" transform="translate(-899.509 -380.668)" fill="#e0e1e2" />
                                                        </g>
                                                    </g>
                                                </svg>
                                            </Menu.Item>
                                        </div>

                                        <div style={{position:"absolute"}}>

                                            {this.props.showNavMenu && <TopNavigationBarNew closeNavMenu={this.props.closeNavMenu} />}
                                        </div>
                                    </div>
                                }

                                {this.props.loggedIn &&
                                    <Menu.Item>
                                        <Dropdown className="loggedin-user" text={`${this.props?.currentUser?.firstName?.charAt(0)}`} >
                                            <Dropdown.Menu>
                                                <div className="balloon">
                                                    <div>
                                                        <div>{`${this.props?.currentUser?.firstName?.charAt(0)}`}</div>
                                                    </div>
                                                    <div className={"user-name"}>
                                                        <p>
                                                            {`${this.props?.currentUser?.firstName} ${this.props?.currentUser?.lastName}`}
                                                        </p>
                                                    </div>
                                                </div>
                                                {this.props.showMenuBar && <> {
                                                    _.orderBy(this.props.routes, ['name'], ['asc']).map(({ path, icon, name, showInSideBar }, key) => (
                                                        showInSideBar && ((this.props.showActiveRequests == true && path == NavigationUrls.OPEN_REQUESTS) || path != NavigationUrls.OPEN_REQUESTS) &&
                                                        <Dropdown.Item key={key} text={name} onClick={() => {
                                                            this.props.closeNavMenu();
                                                            this.props.history.push({
                                                                pathname: path,
                                                                state: { visitTime: moment().unix() }
                                                            });

                                                        }} icon={icon} />


                                                    ))
                                                }
                                                    <Dropdown.Item onClick={() => {
                                                        this.props.closeNavMenu();
                                                        this.props.history.push({
                                                            pathname: '/change-password',
                                                            state: { visitTime: moment().unix() }
                                                        })
                                                    }} text="Change Password" icon="key" /> </>}
                                                <Dropdown.Item text="Sign Out" icon="sign-out" onClick={logout} />



                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </Menu.Item>
                                }
                            </Menu.Menu>



                        </Menu>

                    </div>
                </div>
            </div>
        )
    }
}
function mapStateToProps({ auth, reducer, appView, seller }) {
    //Whatever is returned from this function will end up
    // as props inside of this container component
    return {
        loggedIn: auth.loggedIn,
        currentUser: auth.currentUser,
        loginError: auth.loginError,
        homeScreenLoading: reducer.homeScreenLoading,
        showSidebar: appView.showSidebar,
        seller: seller
    }
}

// function mapDispatchToProps(dispatch) {
//     return bindActionCreators({
//         setAuthState,
//         setShowSidebar,
//         setSellerProfileCompleted,
//         setActiveSubscriptionCount,
//         setInActiveSubscriptionCount
//     }, dispatch);
// }

export default withRouter(connect(mapStateToProps, /*mapDispatchToProps*/)(TopPanel));
